import { defineMessages, useIntl } from 'react-intl';

const messages = defineMessages({
  competencies: {
    id: 'area.info.competencies',
    defaultMessage: 'Competencies',
  },
  addressAndHours: {
    id: 'area.info.addressandhours',
    defaultMessage: 'Address and hours',
  },
});

export const nl2elements = (text) => {
  if (!text) return null;
  const paragraphs = text.split(/\n{2,}/).filter(Boolean);
  return paragraphs.map((p, idx) => {
    const lines = p.split(/\n/);
    const withLineBreaks = lines.reduce((acc, line, i) => {
      acc.push(line);
      if (i < lines.length - 1) acc.push(<br key={`br-${idx}-${i}`} />);
      return acc;
    }, []);
    return (
      <p key={idx} className="m-0">
        {withLineBreaks}
      </p>
    );
  });
};

// Componente base genérico: apenas renderiza conteúdo da área (sem título/dropdown)
const AreaInfoBase = ({ areaData }) => {
  const intl = useIntl();
  if (!areaData) return null;
  const { description, competencies, address_and_hours } = areaData;
  if (!description && !competencies && !address_and_hours) return null;

  return (
    <div className="d-flex flex-column gap-4">
      {description && <p className="documentDescription mb-1">{description}</p>}
      <div className="d-flex gap-2">
        {competencies && (
          <div className="d-flex flex-column flex-grow-1 mr-4">
            <div className="label">
              {intl.formatMessage(messages.competencies)}
            </div>
            <div className="d-flex flex-column">
              {nl2elements(competencies)}
            </div>
          </div>
        )}
        {address_and_hours && (
          <div className="d-flex flex-column mr-4">
            <div className="label text-nowrap">
              {intl.formatMessage(messages.addressAndHours)}
            </div>
            <div className="d-flex flex-column">
              {nl2elements(address_and_hours)}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default AreaInfoBase;
